
/**
 * 강의 초안 목록 조회를 위한 요약 정보
 */
export type GetCourseDrafts200ContentItem = {
  /** 강의 초안 ID */
  id: number;
  /** 현재 이 초안이 실제 발행된 코스와 연결되어 있는지 여부 */
  isPublished?: boolean;
  /** 강의 초안 제목 */
  title: string;
  /** 마지막 수정 시간 */
  updatedAt: string;
};
